const concat = (list) => Array.prototype.concat.bind(list);
const promiseConcat = (f) => (x) =>
  f()
    .then(concat(x))
    .catch((err) => console.log(err, 'err'));
const promiseReduce = (acc, x) =>
  acc.then(promiseConcat(x)).catch((err) => console.log(err, 'err'));

export const serializeFuncs = (funcs) => funcs.reduce(promiseReduce, Promise.resolve([]));
